export interface BitcoinEncodedConfig {
    data?: string;
    to: string;
    value: string;
    inputIndexes?: number[];
}
